import { HOT_TOPICS } from "../../../mocks/gossip";
import { HotTag, SectionHead } from "./Shared";

const RANK_STYLE = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-background-50",
  "bg-secondary-500 text-background-50",
];
const RANK_ICON = ["ri-vip-crown-2-fill", "ri-goblet-fill", "ri-medal-2-fill"];

export default function HotRank() {
  return (
    <section id="topics" className="w-full py-10 md:py-14" aria-label="话题热榜">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <SectionHead
              eyebrow="HOT RANKING"
              anchor="topics"
              title="话题热榜 · 今日排行"
              desc="今日讨论度最高的前八话题，按实时热度滚动更新。点击即可回到对应的最新瓜料。"
            />
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 border border-primary-200 px-3 py-1 text-xs font-semibold text-primary-700">
                <i className="ri-refresh-line" /> 每 10 分钟更新
              </span>
            </div>
          </div>

          <ol className="space-y-2.5 lg:col-span-2" aria-label="热门话题榜单">
            {HOT_TOPICS.map((t) => {
              const top = t.rank <= 3;
              return (
                <li key={t.rank}>
                  <a
                    href="#today"
                    className={`group flex items-center gap-3 rounded-xl border px-3 py-2.5 transition-colors md:px-4 ${
                      top
                        ? "border-background-200 bg-background-100/80 hover:border-primary-300"
                        : "border-background-200/70 bg-background-100/40 hover:border-primary-200"
                    }`}
                  >
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg font-label text-sm font-bold ${
                        top ? RANK_STYLE[t.rank - 1] : "bg-background-200/70 text-foreground-600"
                      }`}
                    >
                      {top ? <i className={`${RANK_ICON[t.rank - 1]} text-sm`} /> : t.rank}
                    </span>
                    <span className="flex-1 truncate text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700 md:text-[15px]">
                      {t.title}
                    </span>
                    <span className="hidden items-center gap-1 text-xs text-foreground-500 sm:flex">
                      <i className="ri-fire-line text-primary-500" />
                      {t.heat}
                    </span>
                    <HotTag label={t.tag} tone={t.tag === "爆" ? "boom" : t.tag === "热" ? "hot" : "new"} />
                  </a>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}